<script setup lang="ts">
import { ShieldCheckIcon } from "@heroicons/vue/24/solid";

const data = usePostStore();

const supportMenus = data.getSupportPages;
const companyMenus = data.getCompanyPages;
</script>

<template>
  <footer class="bg-primary pb-8">
    <div
      class="mx-auto flex flex-col px-4 py-6 text-white md:max-w-5xl md:flex-row md:justify-between"
    >
      <div class="md:max-w-80">
        <label for="location" class="block text-sm font-medium leading-6"
          >About BaliXperiences</label
        >
        <p>
          Bali Xperiences is a premier travel company, Localy owned and operated
          by local expert specializing in creating unforgettable journeys to the
          beautiful island of Bali.
        </p>
      </div>
      <FooterMenu class="md:max-w-60" title="Support" :menus="supportMenus" />
      <FooterMenu class="md:max-w-60" title="Company" :menus="companyMenus" />
      <div
        class="mt-4 w-full border-t-[0.5px] pt-4 md:ml-6 md:mt-0 md:max-w-60 md:border-none"
      >
        <div class="mb-3">
          <h3 class="font-medium">Ways You Can Pay</h3>
        </div>
        <div class="flex flex-wrap justify-start gap-2">
          <div class="flex items-center space-x-2">
            <ShieldCheckIcon class="h-4 text-green-500 md:block" />
            <span>Secured payment: </span>
          </div>
          <div class="flex space-x-2">
            <img
              src="/images/visa.png"
              alt="visa"
              class="h-6 rounded-sm bg-white p-0.5"
            />
            <img
              src="/images/mastercard.png"
              alt="mastercard"
              class="h-6 rounded-sm"
            />
            <img
              src="/images/union-pay.png"
              alt="union pay"
              class="h-6 rounded-sm"
            />
            <img src="/images/paypal.png" alt="paypal" class="h-6 rounded-sm" />
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col space-y-3 px-4 py-4 text-white">
      <div class="text-center">
        ©2019 - 2025 BaliXperience. Made in Bali with Love.
      </div>
      <div class="flex justify-center space-x-4">
        <img src="/images/youtube.png" alt="youtube" class="h-7" />
        <img src="/images/facebook.png" alt="facebook" class="h-7" />
        <img src="/images/instagram.png" alt="instagram" class="h-7" />
        <img src="/images/x.png" alt="twitter" class="h-7" />
      </div>
    </div>
  </footer>
</template>
